// extracted by mini-css-extract-plugin
export default {"Tooltip-wrapper":"ToolTip_Tooltip-wrapper__NxYLW","Tooltip-tip":"ToolTip_Tooltip-tip__RcMRq","top":"ToolTip_top__JXc+M"};